export default __webpack_public_path__ + "static/media/started_crown.bd4d2160.svg";